const formatCnpjOrCpf = {
    install(Vue) {
        Vue.filter('formatCnpjOrCpf', (CnpjOrCpf, documentType) => {
            if (!CnpjOrCpf) return
            CnpjOrCpf = typeof CnpjOrCpf != 'string' ? CnpjOrCpf.toString() : CnpjOrCpf;
            if (documentType == 'F') {
                CnpjOrCpf = CnpjOrCpf.padStart(11, '0');
                CnpjOrCpf = CnpjOrCpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
            } else {
                CnpjOrCpf = CnpjOrCpf.padStart(14, '0');
                CnpjOrCpf = CnpjOrCpf.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');

            }
            return CnpjOrCpf;
        });
    },
};

export default formatCnpjOrCpf